import authCodes from "../../errorCodes/Auth"

export default function (code: string) {
  switch (code) {
    case authCodes.OTACAttemptsExceeded:
      return "errors.mfa.PBAUTHOTACAttemptsExceeded"
    case authCodes.InvalidMFA:
      return "errors.mfa.PBAUTHInvalidMFA"
    case authCodes.AttemptsExceededMFA:
      return "errors.mfa.PBAUTHMFAAttemptsExceeded"
    default:
      return ""
  }
}
